module.exports = __webpack_public_path__ + "officialStatic/img/x-desc.3dcc9e8.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/image/xplan/x-desc.png
// module id = beT5
// module chunks = 0